import styled from "styled-components";
import {NavLink, useRouteMatch} from "react-router-dom";
import React from "react";

const SllNavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
`;
const SllNavigationButton = styled.button`
  border-radius: 6px;
  height: 30px;
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  background-color: ${props => props.theme.color.white_201};
  color: ${props => props.theme.color.dark_200};
  border: 1px solid ${props => props.theme.color.default_border_color};

  &:hover {
    background-color: ${props => props.theme.color.white_200};
  }

  &.selected {
    background-color: ${props => props.theme.color.green_200};
    color: ${props => props.theme.color.green_100};
    border-color: ${props => props.theme.color.green_100};
  }
`;
const SllNavigation = () => {
    const pathname = useRouteMatch();


    return (
        <SllNavigationWrapper>
            <NavLink to={'/sll/winter'}>
                <SllNavigationButton className={pathname.path === '/sll/winter' ? 'selected' : ""}>
                    2025 SLL WINTER
                </SllNavigationButton>
            </NavLink>
            <NavLink to={'/sll'}>
                <SllNavigationButton className={pathname.path === '/sll' ? 'selected' : ""}>
                    2025 SLL SUMMER
                </SllNavigationButton>
            </NavLink>
        </SllNavigationWrapper>
    )
}

export default SllNavigation